import React from 'react';

import { useTypewriterText } from '../../../hooks/useTypewriterText';

interface TypewriterProps {
    text: string;
    delay?: number;
    style?: string;
}

export const Typewriter: React.FC<TypewriterProps> = ({ text, delay = 50, style }) => {
    const currentText = useTypewriterText(text, delay);

    return (
        <div className={style}>{currentText}</div>
    );
};
